import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  Input,
  EventEmitter,
  Output,
  OnChanges,
} from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";

import * as moment from "moment";
import { environment } from "src/environments/environment";

declare let $: any;
declare let window: any;
declare let html2pdf: any;
declare let Jhxlsx: any;

interface TriggerFormData {
  runForAll: boolean;
  master_account_ids: string[];
}

interface TriggerPayload {
  month?: number;
  year?: number;
  master_account_ids?: string[];
}

interface TriggerResponse {
  statusCode: number;
  body: {
    records_pushed: number;
    total_records: number;
  };
}

// Extend window object to allow angularComponentReference
declare global {
  interface Window {
    angularComponentReference: {
      zone: NgZone;
      componentFn: () => void;
      component: any;
    };
  }
}

@Component({
  selector: "app-trigger-process",
  templateUrl: "./trigger-process.component.html",
  styleUrls: ["./trigger-process.component.css"],
})
export class TriggerProcessComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();
  formData: TriggerFormData = {
    runForAll: false,
    master_account_ids: [],
  };

  monthYear: string = "";
  allAccountsList: any = [];

  response: TriggerResponse | null = null;

  constructor(
    public zone: NgZone,
    private apiServer: APIService,
    public notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.monthYear = moment().startOf("month").format("MM-YYYY");

    // Initialize selectpicker
    setTimeout(() => {
      $("#masterAccountSelect").selectpicker();
    });

    // Init datepicker
    $(".datetimepicker")
      .datepicker({
        autoclose: true,
        minViewMode: 1,
        format: "mm-yyyy",
        orientation: "bottom auto",
        endDate: new Date(),
      })
      .on("changeDate", (selected: any) => {
        $(".datetimepicker").val(
          moment(selected["dates"][0]).format("MM-YYYY")
        );
        this.zone.run(() => {
          this.load();
        });
      });

    $(".datetimepicker").val(this.monthYear);

    // Setup Angular reference for external callback
    window.angularComponentReference = {
      zone: this.zone,
      componentFn: () => {
        setTimeout(() => this.load(), 100);
      },
      component: this,
    };

    // Initial load
    setTimeout(() => {
      this.load();
      $("#masterAccountSelect").selectpicker("refresh");
    }, 100);
  }

  onRunForAllChange() {
    setTimeout(() => {
      $("#masterAccountSelect").selectpicker("refresh");
    }, 0);
  }

  async load() {
    this.notifier.loading(true);

    let headers: any = {
      Authorization: localStorage.getItem("t"),
    };

    let apiURL: string = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/accounts`;

    let result = await this.apiServer.getDataPromis(apiURL, {}, {});
    this.allAccountsList = result.accounts;

    console.log("result", result);

    setTimeout(() => {
      $("#masterAccountSelect").selectpicker("refresh");
    }, 100);

    this.notifier.loading(false);

    // Simulate API response
  }

  async process() {
    this.notifier.loading(true);

    const [monthStr, yearStr] = ($(".datetimepicker").val() as string).split(
      "-"
    );

    let data: any = {
      month: parseInt(monthStr),
      year: parseInt(yearStr),
      master_account_ids: this.formData.runForAll
        ? []
        : this.formData.master_account_ids,
    };

    let header: any = {
      Authorization: localStorage.getItem("t"),
    };

    let apiURL: string = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/process`;

    let result: any = await this.apiServer.postDataPromis(apiURL, data, header);

    console.log(result);
    const alertMsg =
      `Records Pushed: ${result.records_pushed}<br>` +
      `Total Records: ${result.total_records}<br>` +
      `Status: ${result.status}<br>` +
      `Message: ${result.message}`;

    this.notifier.alert("Info", "", alertMsg, "info", 5000);
    this.closeModal.emit();
    this.notifier.loading(false);
  }
}
